<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <emission-form />
  </v-container>
</template>

<script>
import EmissionForm from './_Form'
export default {
  name: 'AdminMasterEmissionEdit',
  components: {EmissionForm},
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '排出事業者一覧', disabled: false, to: '/admin/masters/emissions', exact: true },
        { text: '排出事業者追加', disabled: true, to: '' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
